










































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  filters: {
    truncate: function(text: string, length: number, suffix: string) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    }
  }
})
export default class ButtonModal extends Vue {
  @Prop() private heading!: string;
  @Prop() private text!: string;
  @Prop() private cssClass!: string;
  @Prop({ default: "info-circle" }) private icon!: string;
  public hidden = true;

  modalShow() {
    this.hidden = false;
  }

  modalHide() {
    this.hidden = true;
  }

  get customVuexStyles() {
    return {
      "--font-main": this.$store.state.globalCss.fontMain,
      "--modal-color": this.$store.state.globalCss.colors.modal.color,
      "--modal-bg-color": this.$store.state.globalCss.colors.modal
        .backgroundColor
    };
  }
}
